// VUE IMPORTS
import Vue from 'vue'
import Router from 'vue-router'
import store from '../stores/index'

// LANDING (root of domain)

import callback from '@/components/landing/callback'

// ADMIN DASHBOARD
import logout from '@/components/dashboard/logout'

// SETTINGS

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/callback',
            name: 'callback',
            component: callback,
        },
        {
            path: '/logout',
            name: 'logout',
            component: logout,
        },
        {
            path: '/',
            name: 'dashboard',
            component: () => import('@/components/dashboard/dashboard'),
            children: [
                {
                    name: 'payment',
                    path: 'payment',
                    component: () => import('@/components/dashboard/payment'),
                    beforeEnter: adminGuard,
                },
                {
                    name: 'loggedinlanding',
                    path: '/',
                    component: () => import('@/components/dashboard/landing'),
                },
                {
                    path: 'settings',
                    children: [
                        {
                            name: 'general',
                            path: '/',
                            component: () => import('@/components/dashboard/settings/general/general'),
                        },
                        {
                            name: 'buttons',
                            path: 'buttons',
                            component: () => import('@/components/dashboard/settings/buttons/buttons'),
                        },
                        {
                            name: 'tickets',
                            path: 'tickets',
                            component: () => import('@/components/dashboard/settings/tickets/tickets'),
                        },
                        {
                            name: 'staff',
                            path: 'staff',
                            component: () => import('@/components/dashboard/settings/staff/staff'),
                        },
                        {
                            name: 'subjects',
                            path: 'subjects',
                            component: () => import('@/components/dashboard/settings/subjects/subjects'),
                        },
                        {
                            name: 'logging',
                            path: 'logging',
                            component: () => import('@/components/dashboard/settings/logging/logging'),
                        },
                        {
                            name: 'panels',
                            path: 'panels',
                            component: () => import('@/components/dashboard/settings/panels'),
                        },
                    ],
                    component: () => import('@/components/dashboard/settings/settings'),
                    beforeEnter: adminGuard,
                },
                {
                    name: 'subjects_edit',
                    path: 'settings/subject/:category/:subject',
                    component: () => import('@/components/dashboard/settings/subjects/subjects_edit'),
                },
                {
                    name: 'ticket',
                    path: 'ticket/:id',
                    component: () => import('@/components/dashboard/ticket/ticket'),
                },
                {
                    path: 'stats',
                    name: 'stats',
                    component: () => import('@/components/dashboard/apexstats'),
                },
            ],
        },
        {
            path: '/ticket/:id',
            name: 'ticket',
            component: () => import('@/components/dashboard/dashboard'),
        },
    ],
})

function adminGuard(to, from, next) {
    if (!store.getters.staffGuild) return router.push('/')
    if (store.getters.hasAdminPerms(store.getters.staffGuild)) {
        return next()
    }
}

router.beforeEach((to, from, next) => {
    const ingoredPages = ['callback', 'logout']
    if (ingoredPages.includes(to.name)) return next()
    if (store.getters.isAuthenticated) {
        next()
    } else {
        if (from.name == 'logout') {
            return next()
        } else {
            store.dispatch('startLogin', to.fullPath)
        }
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js